import common from "../common.js";

export default {
  async setContainersStatusFilter(context, payload) {
    context.commit("setContainersStatusFilter", payload);
  },

  async setContainersFilteredList(context, payload) {
    context.commit("setContainersFilteredList", payload);
  },

  async loadContainers(context, payload) {
    const responseJson = await common.getRequest(
      context,
      payload,
      "containers"
    );
    const responseData = [];

    for (const key in responseJson) {
      const cont = {
        containerId: responseJson[key].containerId,
        containerTypeId: responseJson[key].containerTypeId,
        operatorId: responseJson[key].operatorId,
        divisionId: responseJson[key].divisionId,
        areaId: responseJson[key].areaId,
        containerName: responseJson[key].containerName,
        serialnum: responseJson[key].serialnum,
        latitude: responseJson[key].latitude,
        longitude: responseJson[key].longitude,
        altitude: responseJson[key].altitude,
      };

      responseData.push(cont);
    }
    context.commit("setContainers", responseData);
  },

  async loadContainer(context, payload) {
    const id = payload.id;

    let container = {
      containerId: 0,
      containerTypeId: 0,
      operatorId: 0,
      divisionId: 0,
      areaId: 0,
      containerName: "",
      serialnum: "",
      latitude: 0,
      longitude: 0,
      altitude: 0,
    };

    if (id != 0) {
      const responseData = await common.getRequest(
        context,
        payload,
        `containers/${id}`
      );
      container = {
        containerId: responseData.containerId,
        containerTypeId: responseData.containerTypeId,
        operatorId: responseData.operatorId,
        divisionId: responseData.divisionId,
        areaId: responseData.areaId,
        containerName: responseData.containerName,
        serialnum: responseData.serialnum,
        latitude: responseData.latitude,
        longitude: responseData.longitude,
        altitude: responseData.altitude,
      };
    }
    context.commit("setContainer", container);
  },

  async clearContainerHistory(context, payload) {
    context.commit("setContainerHistory", []);
    context.commit("setContainerHistoryDetail", []);
    context.commit("setContainerHistoryExtended", []);
  },

  async loadContainerHistory(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var containerId = Number.isInteger(payload) ? payload : payload.containerId;
    var { fromDate, toDate } = payload;

    var url = Number.isInteger(payload)
      ? `${apiUrl}/containers/${containerId}/history`
      : `${apiUrl}/containers/${containerId}/history?fromDate=${fromDate}&toDate=${toDate}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });
    const responseData = await response.json();
    // console.log("loadContainerHistory")
    if (!response.ok) {
      //error, NOT ok
      const error = new Error(responseData.message || "Failed to fetch.");
      throw error;
    }
    const containerHist = [];

    for (const key in responseData) {
      if (responseData[key].propertyType == "DATE") {
        //console.log(prop.propValue);
        responseData[key].propValue = new Date(
          responseData[key].propValue + " UTC"
        ).toLocaleString("en-CA", { dateStyle: "short", timeStyle: "short" });
        //console.log(prop.propValue);
      }
      const histEntry = {
        historyId: responseData[key].historyId,
        containerId: responseData[key].containerId,
        containerName: responseData[key].containerName,
        propertyId: responseData[key].propertyId,
        historyDate: new Date(responseData[key].historyDate),
        propValue: responseData[key].propValue,
        historyType: responseData[key].historyType,
        notes: responseData[key].notes,
        propertyName: responseData[key].propertyName,
      };
      containerHist.push(histEntry);
    }
    context.commit("setContainerHistory", containerHist);
  },

  async loadContainerHistoryDetail(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var containerId = Number.isInteger(payload) ? payload : payload.containerId;
    var { fromDate, toDate } = payload;
    // console.log("HISTORY DETAIL", payload);
    var url = Number.isInteger(payload)
      ? `${apiUrl}/containers/${containerId}/historydetails`
      : `${apiUrl}/containers/${containerId}/historydetails?fromDate=${fromDate}&toDate=${toDate}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });
    const responseData = await response.json();

    if (!response.ok) {
      //error, NOT ok
      const error = new Error(responseData.message || "Failed to fetch.");
      throw error;
    }
    const containerHistDetail = [];

    for (const key in responseData) {
      const histEntry = {
        historyId: responseData[key].historyId,
        containerId: responseData[key].containerId,
        propertyId: responseData[key].propertyId,
        propertyName: responseData[key].propertyName,
        historyDate: new Date(responseData[key].historyDate),
        propValue: responseData[key].propValue,
        historyType: responseData[key].historyType,
        notes: responseData[key].notes,
      };
      containerHistDetail.push(histEntry);
    }
    // console.log("HISTORYDETAIL", containerHistDetail);
    context.commit("setContainerHistoryDetail", containerHistDetail);
  },
  
  async loadContainerHistoryExtended(context, payload) {
    const responseJson = await common.getRequest(
      context,
      payload,
      `containers/${payload}/history/extended`
    );
    const responseData = [];

    for (const key in responseJson) {
      const histEntry = {
        historyId: responseJson[key].historyId,
        containerId: responseJson[key].containerId,
        propertyId: responseJson[key].propertyId,
        historyDate: new Date(
          responseJson[key].historyDate
        ).toLocaleDateString(),
        // historyDate: responseData[key].historyDate.substring(0,11),
        propValue: responseJson[key].propValue,
        historyType: responseJson[key].historyType,
        notes: responseJson[key].notes,
        propertyName: responseJson[key].propertyName,
      };
      // console.log(histEntry);
      responseData.push(histEntry);
    }
    context.commit("setContainerHistoryExtended", responseData);
  },

  async resetContainerPropertyHistory(context, payload) {
    context.commit("setContainerPropertyHistory", "");
  },

  async loadContainerPropertyHistory(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/containers/${payload.container}/history/${payload.propertyName}`;

    //var url = `https://r3backendprd.azurewebsites.net/api/containers/${payload}/history`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });
    const responseData = await response.json();

    if (!response.ok) {
      //error, NOT ok
      const error = new Error(responseData.message || "Failed to fetch.");
      throw error;
    }
    const containerHist = [];

    for (const key in responseData) {
      if (responseData[key].propertyType == "DATE") {
        responseData[key].propValue = new Date(
          responseData[key].propValue + " UTC"
        ).toLocaleString("en-CA", { dateStyle: "short", timeStyle: "short" });
      }
      const histEntry = {
        historyId: responseData[key].historyId,
        containerId: responseData[key].containerId,
        containerName: responseData[key].containerName,
        propertyId: responseData[key].propertyId,
        historyDate: new Date(responseData[key].historyDate),
        propValue: responseData[key].propValue,
        historyType: responseData[key].historyType,
        notes: responseData[key].notes,
        propertyName: responseData[key].propertyName,
      };
      containerHist.push(histEntry);
    }
    context.commit("setContainerPropertyHistory", containerHist);
  },

  async loadContainersGridInfo(context, payload) {
    const responseJson = await common.getRequest(
      context,
      payload,
      "containers/compact"
    );
    const responseData = [];

    for (const key in responseJson) {
      const container = {
        containerId: responseJson[key].id,
        typeId: responseJson[key].type,
        operatorId: responseJson[key].oper,
        divisionId: responseJson[key].div,
        areaId: responseJson[key].area,
        containerName: responseJson[key].name,
        serialnum: responseJson[key].sn,
        properties: [],
      };

      for (const propKey in responseJson[key].properties) {
        var containerProperty = {
          propertyId: responseJson[key].properties[propKey].prop,
          propertyValue: responseJson[key].properties[propKey].value,
        };
        container.properties.push(containerProperty);
      }

      responseData.push(container);
    }
    context.commit("setGridContainers", responseData);
  },

  async loadContainersStatusV2(context, payload) {
    const responseJson = await common.getRequest(
      context,
      '',
      "containers/compact/" + payload.typeId
    );
    const containers = [];

    for (const key in responseJson) {
      const container = {
        containerId: responseJson[key].containerId,
        // containerTypeId : responseJson[key].containerTypeId,
        // divisionId : responseJson[key].divisionId,
        // operatorId : responseJson[key].operatorId,
        // areaId : responseJson[key].areaId,
        // officeId : responseJson[key].officeId,
        // districtId : responseJson[key].districtId,
        containerStatus: responseJson[key].containerStatus,
        containerName: responseJson[key].containerName,
        // containerType : responseJson[key].containerType,
        // division : responseJson[key].division,
        operator: responseJson[key].operator,
        // operatorExternal : responseJson[key].operatorExternal,
        area: responseJson[key].area,
        // office : responseJson[key].office,
        // district : responseJson[key].district,
        // latitude : responseJson[key].latitude,
        // longitude : responseJson[key].longitude,
        devices: responseJson[key].devices,
        properties: responseJson[key].containerProperties,
      };
      switch (container.containerStatus) {
        case "good":
          container.containerStatus = "✔️";
          break;
        case "marginal":
          container.containerStatus = "⚠️";
          break;
        case "critical":
          container.containerStatus = "❌";
          break;
      }

      //dynamically add properties into the container (ie flatten the json obj)
      // var propNames = Object.keys(responseJson[key].containerProperties);
      // for (const name in propNames)
      // {
      // container[propNames[name]] = responseJson[key].containerProperties[propNames[name]];
      // }

      // for each device in the container
      for (const device in responseJson[key].deviceDetails) {
        // add device properties into the container
        // this can cause issues with duplicate data though (ex Signal Strength)
      }
      containers.push(container);
    }

    for (const key in containers) {
      delete Object.assign(containers[key], {surface: containers[key]["containerName"] })["containerName"];
      // delete Object.assign(containers[key], {id: containers[key]["containerId"] })["containerId"];
      // delete Object.assign(containers[key], {status: containers[key]["containerStatus"] })["containerStatus"];
    }
    // console.log(containers)
    context.commit("setContainersV2", containers);
  },

  async loadContainersStatus(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/containers/details`;
    // var url = "https://r3backendprd.azurewebsites.net/api/containers/details";

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });
    const responseData = await response.json();

    if (!response.ok) {
      //error, NOT ok
      const error = new Error(responseData.message || "Failed to fetch.");
      throw error;
    }
    const gridContainers = [];

    for (const key in responseData) {
      var gridContainer = {
        containerId: responseData[key].containerId,
        containerName: responseData[key].containerName,
        containerType: responseData[key].containerType,
        containerTypeId: responseData[key].containerTypeId,
        area: responseData[key].area,
        division: responseData[key].division,
        operator: responseData[key].operator,
        serialnum: responseData[key].serialnum,
        latitude: responseData[key].latitude,
        longitude: responseData[key].longitude,
        containerStatus: "✔️",
        properties: responseData[key].containerPropActuals,
      };

      const containerProps = [];

      for (const propKey in responseData[key].containerPropActuals) {
        var prop = responseData[key].containerPropActuals[propKey];
        let propStatus = "�";

        if (prop.propertyType == "NUMBER" || prop.propertyType == "DECIMAL") {
          prop.propValue = parseFloat(prop.propValue);

          if (isNaN(prop.propValue)) {
            prop.propValue = 0;
          } else {
            prop.propValue = Math.round(prop.propValue * 10) / 10;
          }

          propStatus = "✔️";

          if (
            (prop.valueMarginal && prop.propValue < prop.valueMarginal) ||
            (prop.valueHighMarginal && prop.propValue > prop.valueHighMarginal)
          ) {
            propStatus = "⚠️";
            gridContainer.containerStatus =
              gridContainer.containerStatus == "✔️"
                ? "⚠️"
                : gridContainer.containerStatus;
          }

          if (
            (prop.valueCritical && prop.propValue < prop.valueCritical) ||
            (prop.valueHighCritical && prop.propValue > prop.valueHighCritical)
          ) {
            propStatus = "❌";
            gridContainer.containerStatus = gridContainer.containerStatus =
              "❌";
          }
        }

        if (prop.propertyType == "DATE") {
          //console.log(prop.propValue);
          prop.propValue = new Date(prop.propValue + " UTC").toLocaleString(
            "en-CA",
            { dateStyle: "short", timeStyle: "short" }
          );
          //console.log(prop.propValue);
        }

        var containerProp = {
          containerPropId: prop.containerPropId,
          propertyId: prop.propertyId,
          propertyName: prop.propertyName,
          propertyType: prop.propertyType,
          propertyClassId: prop.propertyClassId,
          propValue: prop.propValue,
          valueMarginal: prop.valueMarginal,
          valueCritical: prop.valueCritical,
          valueHighMarginal: prop.valueHighMarginal,
          valueHighCritical: prop.valueHighCritical,
          propertyImgName: `img/${prop.propertyImgName}`,
          propertySort: prop.propertySort,
          status: propStatus,
          useThresholds: !!prop.useThresholds,
          useHighThresholds: !!prop.useHighThresholds,
          uiShowList: prop.uiShowList,
        };
        containerProps.push(containerProp);
      }
      gridContainer.properties = containerProps;
      gridContainers.push(gridContainer);
    }
    //console.log("LOADED CONTAINERS (Action)",gridContainers)
    context.commit("setContainersStatus", gridContainers);
  },

  async loadContainerStatus(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/containers/${payload}/details`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
    });
    const responseData = await response.json();

    if (!response.ok) {
      //error, NOT ok
      const error = new Error(responseData.message || "Failed to fetch.");
      throw error;
    }

    var gridContainer = {
      containerId: responseData.containerId,
      containerName: responseData.containerName,
      containerType: responseData.containerType,
      area: responseData.area,
      division: responseData.division,
      operator: responseData.operator,
      serialnum: responseData.serialnum,
      latitude: responseData.latitude,
      longitude: responseData.longitude,
      containerStatus: "✔️",
      properties: responseData.containerPropActuals,
    };

    const containerProps = [];

    for (const propKey in responseData.containerPropActuals) {
      var prop = responseData.containerPropActuals[propKey];
      let propStatus = "�";

      if (prop.propertyType == "NUMBER" || prop.propertyType == "DECIMAL") {
        prop.propValue = parseFloat(prop.propValue);

        if (isNaN(prop.propValue)) {
          prop.propValue = 0;
        } else {
          prop.propValue = Math.round(prop.propValue * 10) / 10;
        }

        propStatus = "✔️";

        if (
          (prop.valueMarginal && prop.propValue < prop.valueMarginal) ||
          (prop.valueHighMarginal && prop.propValue > prop.valueHighMarginal)
        ) {
          propStatus = "⚠️";
          gridContainer.containerStatus =
            gridContainer.containerStatus == "✔️"
              ? "⚠️"
              : gridContainer.containerStatus;
        }

        if (
          (prop.valueCritical && prop.propValue < prop.valueCritical) ||
          (prop.valueHighCritical && prop.propValue > prop.valueHighCritical)
        ) {
          propStatus = "❌";
          gridContainer.containerStatus = gridContainer.containerStatus = "❌";
        }
      }
      if (prop.propertyType == "DATE") {
        //console.log(prop.propValue);
        prop.propValue = new Date(prop.propValue + " UTC").toLocaleString(
          "en-CA",
          { dateStyle: "short", timeStyle: "short" }
        );
        //console.log(prop.propValue);
      }
      var containerProp = {
        containerPropId: prop.containerPropId,
        propertyId: prop.propertyId,
        propertyName: prop.propertyName,
        propertyType: prop.propertyType,
        propertyClassId: prop.propertyClassId,
        propValue: prop.propValue,
        valueMarginal: prop.valueMarginal,
        valueCritical: prop.valueCritical,
        valueHighMarginal: prop.valueHighMarginal,
        valueHighCritical: prop.valueHighCritical,
        propertyImgName: `img/${prop.propertyImgName}`,
        propertySort: prop.propertySort,
        status: propStatus,
        useThresholds: !!prop.useThresholds,
        useHighThresholds: !!prop.useHighThresholds,
        uiShowList: prop.uiShowList,
      };
      containerProps.push(containerProp);
    }
    gridContainer.properties = containerProps;
    context.commit("setContainerStatus", gridContainer);
  },
  async loadContainerProperties(context, payload) {
    const id = payload.id;
    const propData = [];

    if (id != 0) {
      const responseData = await common.getRequest(
        context,
        payload,
        `containers/${id}/properties`
      );
      // const propData = [];
      for (const key in responseData) {
        if (responseData[key].propertyType == "DATE") {
          responseData[key].propValue = new Date(
            responseData[key].propValue + " UTC"
          ).toLocaleString("en-CA", { dateStyle: "short", timeStyle: "short" });
        }
        var containerProp = {
          containerPropId: responseData[key].containerPropId,
          propertyId: responseData[key].propertyId,
          propertyName: responseData[key].propertyName,
          propertyType: responseData[key].propertyType,
          propValue: responseData[key].propValue,
          valueMarginal: responseData[key].valueMarginal,
          valueCritical: responseData[key].valueCritical,
          valueHighMarginal: responseData[key].valueHighMarginal,
          valueHighCritical: responseData[key].valueHighCritical,
          propertyImgName: `img/${responseData[key].propertyImgName}`,
          propertySort: responseData[key].propertySort,
        };
        propData.push(containerProp);
      }
    }
    context.commit("setContainerProps", propData);
  },

  async updateContainerProperties(context, payload) {
    console.log("updateContainerProperties *** ", payload)

    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    
    for (let i = 0; i < payload.length; i++) {
      console.log("updateContainerProperty *** ", payload[i])
      const newRequest = {
        containerPropId: payload[i].containerPropId,
        containerId: payload[i].containerId,
        propertyId: payload[i].propertyId,
        propValue: String(payload[i].propValue),
        valueMarginal: payload[i].marginal || null,
        valueCritical: payload[i].critical || null,
        valueHighMarginal: payload[i].highMarginal || null,
        valueHighCritical: payload[i].highCritical || null,
        propertySort: payload[i].propertySort,
      };

      console.log("updateContainerProperty REQ ", newRequest)
      var apiUrl = context.rootGetters["config/getApiUrl"];
      var url = `${apiUrl}/containerproperties/${payload[i].containerPropId}`;

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: bearer_token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newRequest),
      });

      if (!response.ok) {
        const error = new Error("Failed to send request.");
        throw error;
      }

      // context.commit("updateContainerProperties", payload);
    }
  },

  async updateContainerProperty(context, payload) {
    
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;

    const newRequest = {
      containerPropId: payload.containerPropId,
      containerId: payload.containerId,
      propertyId: payload.propertyId,
      propValue: String(payload.propValue),
      valueMarginal: payload.marginal || null,
      valueCritical: payload.critical || null,
      valueHighMarginal: payload.highMarginal || null,
      valueHighCritical: payload.highCritical || null,
      propertySort: payload.propertySort,
    };

    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/containerproperties/${payload.containerPropId}`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }

    context.commit("updateContainerProperties", payload);
  },

  // Add new map-specific actions:
  async loadContainersForMap(context) {
    try {
      context.commit("setLoadingState", true);
      const token = context.rootGetters["auth/getToken"];
      const apiUrl = context.rootGetters["config/getApiUrl"];

      const response = await fetch(`${apiUrl}/containers/details`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch containers");
      }

      const data = await response.json();

      // Transform API data to match the expected format
      const containers = data.map((container) => ({
        containerId: container.containerId,
        containerName: container.containerName,
        operatorId: container.operatorId,
        areaId: container.areaId,
        chemicalType: container.containerType,
        chemicalName: container.containerType, // Adjust based on API data
        currentLevel: calculateLevel(container.containerPropActuals),
        latitude: container.latitude,
        longitude: container.longitude,
        capacity: getCapacity(container.containerPropActuals),
        lastFilled: getLastFilled(container.containerPropActuals),
        averageConsumption: calculateConsumption(
          container.containerPropActuals
        ),
        daysToEmpty: calculateDaysToEmpty(container.containerPropActuals),
      }));

      context.commit("setContainers", containers);
      return containers;
    } catch (error) {
      console.error("Error loading containers:", error);
      throw error;
    } finally {
      context.commit("setLoadingState", false);
    }
  },

  async updateContainerLocation(context, { containerId, latitude, longitude }) {
    try {
      const token = context.rootGetters["auth/getToken"];
      const bearer_token = "Bearer " + token;
      const apiUrl = context.rootGetters["config/getApiUrl"];
      const url = `${apiUrl}/containers/${containerId}`;

      // Get existing container data first
      const container = context.getters.getContainerById(containerId);
      if (!container) {
        throw new Error("Container not found");
      }

      const updateData = {
        ...container,
        latitude,
        longitude,
      };

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: bearer_token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        throw new Error("Failed to update container location");
      }

      // Update the local state
      context.commit("updateContainerLocation", {
        containerId,
        latitude,
        longitude,
      });
      return true;
    } catch (error) {
      console.error("Error updating container location:", error);
      throw error;
    }
  },

  async updateContainer(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/containers/${payload.containerId}`;

    const newRequest = {
      containerId: payload.containerId,
      containerTypeId: payload.containerTypeId,
      operatorId: payload.operatorId,
      divisionId: payload.divisionId,
      areaId: payload.areaId,
      containerName: String(payload.containerName),
      serialnum: String(payload.serialnum),
      latitude: payload.latitude,
      longitude: payload.longitude,
      altitude: payload.altitude,
    };

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }

    // context.commit('updateContainerProperties', payload);
  },

  async sendActionRequest(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;

    const newRequest = {
      containerId: payload.containerId,
      containerName: payload.containerName,
      requestType: payload.requestType,
      requestInfo: payload.requestInfo,
    };
    var apiUrl = context.rootGetters["config/getApiUrl"];
    // var url = `${apiUrl}/containers/request`;
    var url = `${apiUrl}/ticket/from-request`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }
    // context.commit('updateContainerProperties', payload);
  },

  async clearContainerNotes(context, payload) {
    //reset containerNotes
    context.commit("setContainerNotes", "");
  },
  
  async loadContainerNotes(context, payload) {
    var url = `container/${payload}/notes`;
    const responseJson = await common.getRequest(context, payload, url);
    const responseData = [];

    for (const key in responseJson) {
      const note = {
        containerNoteId: responseJson[key].containerNoteId,
        containerId: responseJson[key].containerId,
        noteTypeId: responseJson[key].noteTypeId,
        noteDate: responseJson[key].noteDate.replace("T", " ").substring(0, 19),
        userId: responseJson[key].userId,
        note: responseJson[key].note,
      };
      responseData.push(note);
    }
    context.commit("setContainerNotes", responseData);
  },

  async addContainerNote(context, payload) {
    const newRequest = {
      containerNoteId: 0,
      containerId: payload.containerId,
      noteTypeId: payload.noteTypeId,
      noteDate: new Date().toISOString(),
      userId: 0,
      note: payload.note,
    };

    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/containernote`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    context.commit("setResponseCode", response.status);

    // response.status ex. 200-OK
    if (!response.ok) {
      //const error = new Error(responseData.message || 'Failed to send request.');
      const error = new Error("Failed to send request.");
      throw error;
    }

    const responseJson = await response.json();
    responseJson.noteDate = responseJson.noteDate
      .replace("T", " ")
      .substring(0, 19);
    // payload.containerNoteId = responseJson.containerNoteId;
    // console.log("PAYLOAD", responseJson);
    context.commit("addContainerNote", responseJson);
  },
  async updateContainerName(context, { containerId, containerName }) {
    try {
      const token = context.rootGetters["auth/getToken"];
      const bearer_token = "Bearer " + token;
      const apiUrl = context.rootGetters["config/getApiUrl"];
      const url = `${apiUrl}/containers/${containerId}`;

      // Only send the field we want to update
      const updateData = {
        containerName: containerName,
      };

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          Authorization: bearer_token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updateData),
      });

      if (!response.ok) {
        throw new Error("Failed to update container name");
      }

      // Update the local state
      context.commit("updateContainerName", {
        containerId,
        containerName: containerName,
      });
      return true;
    } catch (error) {
      console.error("Error updating container name:", error);
      throw error;
    }
  },
};

// Utility functions for container calculations
const calculateLevel = (properties) => {
  const volumeProp = properties.find((p) => p.propertyName === "Volume (%)");
  return volumeProp ? parseFloat(volumeProp.propValue) : 0;
};

const getCapacity = (properties) => {
  const capacityProp = properties.find((p) => p.propertyName === "Capacity");
  return capacityProp ? parseFloat(capacityProp.propValue) : 0;
};

const getLastFilled = (properties) => {
  const lastFilledProp = properties.find(
    (p) => p.propertyName === "Last Fill Date"
  );
  return lastFilledProp ? lastFilledProp.propValue : null;
};

const calculateConsumption = (properties) => {
  const consumptionProp = properties.find(
    (p) => p.propertyName === "Injection Avg"
  );
  return consumptionProp ? parseFloat(consumptionProp.propValue) : 0;
};

const calculateDaysToEmpty = (properties) => {
  const dteProp = properties.find((p) => p.propertyName === "DTE");
  return dteProp ? parseFloat(dteProp.propValue) : 0;
};
